export default {
  navMenuItems: []
}
